import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Highlight from 'react-highlight';

function CodePreview({ code }) {
	return (
		<div className="hljs-container hljs-wrapper rounded-0 rounded-bottom" data-bs-theme="dark">
			<pre>
				<Highlight className="typescript">{code}</Highlight>
			</pre>
		</div>
	);
}

function TableCard({ children, code }) {
	return (
		<div className="card">
			<div className="card-body">{children}</div>
			<CodePreview code={code} />
		</div>
	);
}

function StandardRows({ className = '' }) {
	return (
		<tbody>
			<tr className={className}>
				<th scope="row">1</th>
				<td>Mark</td>
				<td>Otto</td>
				<td>@mdo</td>
			</tr>
			<tr className={className}>
				<th scope="row">2</th>
				<td>Jacob</td>
				<td>Thornton</td>
				<td>@fat</td>
			</tr>
			<tr className={className}>
				<th scope="row">3</th>
				<td>Larry</td>
				<td>the Bird</td>
				<td>@twitter</td>
			</tr>
		</tbody>
	);
}

function TableHeader() {
	return (
		<tr>
			<th scope="col">#</th>
			<th scope="col">First</th>
			<th scope="col">Last</th>
			<th scope="col">Handle</th>
		</tr>
	);
}

function TableElements() {
	const [code1, setCode1] = useState();
	const [code2, setCode2] = useState();
	const [code3, setCode3] = useState();
	const [code4, setCode4] = useState();
	const [code5, setCode5] = useState();
	const [code6, setCode6] = useState();
	const [code7, setCode7] = useState();
	const [code8, setCode8] = useState();
	const [code9, setCode9] = useState();
	const [code10, setCode10] = useState();

	useEffect(() => {
		fetch('/color-admin/admin/react/assets/data/table-elements/code-1.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode1(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-2.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode2(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-3.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode3(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-4.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode4(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-5.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode5(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-6.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode6(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-7.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode7(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-8.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode8(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-9.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode9(html);
			});
		fetch('/color-admin/admin/react/assets/data/table-elements/code-10.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode10(html);
			});
	}, []);

	return (
		<>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<Link to="/table/elements">Tables</Link>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									Table Elements <small>page header description goes here...</small>
								</h1>
								<hr className="mb-4" />
								<div id="basicTable" className="mb-5">
									<h4>Basic Table</h4>
									<p>
										Using the most basic table markup, here’s how .table-based tables look in
										Bootstrap. You can also invert the colors—with <code>.table-dark</code>.
									</p>
									<TableCard code={code1}>
										<div className="row mb-n3">
											<div className="col-xl-6">
												<div className="small text-inverse text-opacity-50 mb-3">
													<b className="fw-bold">DEFAULT TABLE</b>
												</div>
												<table className="table">
													<thead>
														<TableHeader />
													</thead>
													<StandardRows />
												</table>
											</div>
											<div className="col-xl-6">
												<div className="small text-inverse text-opacity-50 mb-3">
													<b className="fw-bold">DARK TABLE</b>
												</div>
												<table className="table table-dark">
													<thead>
														<TableHeader />
													</thead>
													<StandardRows />
												</table>
											</div>
										</div>
									</TableCard>
								</div>
								<div id="tableHeadOptions" className="mb-5">
									<h4>Table head options</h4>
									<p>
										Similar to tables and dark tables, use the modifier classes{' '}
										<code>.thead-light</code> or <code>.thead-dark</code> to make{' '}
										<code>&lt;thead&gt;</code>s appear light or dark gray.
									</p>
									<TableCard code={code2}>
										<div className="row mb-n3">
											<div className="col-xl-6">
												<div className="small text-inverse text-opacity-50 mb-3">
													<b className="fw-bold">DARK HEADER</b>
												</div>
												<table className="table">
													<thead className="table-dark">
														<TableHeader />
													</thead>
													<StandardRows />
												</table>
											</div>
											<div className="col-xl-6">
												<div className="small text-inverse text-opacity-50 mb-3">
													<b className="fw-bold">LIGHT HEADER</b>
												</div>
												<table className="table">
													<thead className="table-light">
														<TableHeader />
													</thead>
													<StandardRows />
												</table>
											</div>
										</div>
									</TableCard>
								</div>
								<div id="stripedRows" className="mb-5">
									<h4>Striped rows</h4>
									<p>
										Use <code>.table-striped</code> to add zebra-striping to any table row within
										the <code>&lt;tbody&gt;</code>.
									</p>
									<TableCard code={code3}>
										<table className="table table-striped mb-0">
											<thead>
												<TableHeader />
											</thead>
											<StandardRows />
										</table>
									</TableCard>
								</div>
								<div id="borderedTable" className="mb-5">
									<h4>Bordered table</h4>
									<p>
										Add <code>.table-bordered</code> for borders on all sides of the table and
										cells.
									</p>
									<TableCard code={code4}>
										<table className="table table-bordered mb-0">
											<thead>
												<TableHeader />
											</thead>
											<tbody>
												<tr>
													<th scope="row">1</th>
													<td>Mark</td>
													<td>Otto</td>
													<td>@mdo</td>
												</tr>
												<tr>
													<th scope="row">2</th>
													<td>Jacob</td>
													<td>Thornton</td>
													<td>@fat</td>
												</tr>
												<tr>
													<th scope="row">3</th>
													<td colSpan="2">Larry the Bird</td>
													<td>@twitter</td>
												</tr>
											</tbody>
										</table>
									</TableCard>
								</div>
								<div id="borderlessTable" className="mb-5">
									<h4>Borderless table</h4>
									<p></p>
									<TableCard code={code5}>
										<table className="table table-borderless mb-0">
											<thead>
												<TableHeader />
											</thead>
											<tbody>
												<tr>
													<th scope="row">1</th>
													<td>Mark</td>
													<td>Otto</td>
													<td>@mdo</td>
												</tr>
												<tr>
													<th scope="row">2</th>
													<td>Jacob</td>
													<td>Thornton</td>
													<td>@fat</td>
												</tr>
												<tr>
													<th scope="row">3</th>
													<td colSpan="2">Larry the Bird</td>
													<td>@twitter</td>
												</tr>
											</tbody>
										</table>
									</TableCard>
								</div>
								<div id="hoverableRows" className="mb-5">
									<h4>Hoverable rows</h4>
									<p>
										Add <code>.table-hover</code> to enable a hover state on table rows within a{' '}
										<code>&lt;tbody&gt;</code>.
									</p>
									<TableCard code={code6}>
										<table className="table table-hover mb-0">
											<thead>
												<TableHeader />
											</thead>
											<tbody>
												<tr>
													<th scope="row">1</th>
													<td>Mark</td>
													<td>Otto</td>
													<td>@mdo</td>
												</tr>
												<tr>
													<th scope="row">2</th>
													<td>Jacob</td>
													<td>Thornton</td>
													<td>@fat</td>
												</tr>
												<tr>
													<th scope="row">3</th>
													<td colSpan="2">Larry the Bird</td>
													<td>@twitter</td>
												</tr>
											</tbody>
										</table>
									</TableCard>
								</div>
								<div id="smallTable" className="mb-5">
									<h4>Small table</h4>
									<p>
										Add <code>.table-sm</code> to make tables more compact by cutting cell padding
										in half.
									</p>
									<TableCard code={code7}>
										<table className="table table-sm mb-0">
											<thead>
												<TableHeader />
											</thead>
											<tbody>
												<tr>
													<td>1</td>
													<td>Mark</td>
													<td>Otto</td>
													<td>@mdo</td>
												</tr>
												<tr>
													<td>2</td>
													<td>Jacob</td>
													<td>Thornton</td>
													<td>@fat</td>
												</tr>
												<tr>
													<td>3</td>
													<td colSpan="2">Larry the Bird</td>
													<td>@twitter</td>
												</tr>
											</tbody>
										</table>
									</TableCard>
								</div>
								<div id="contextualClasses" className="mb-5">
									<h4>Contextual classes</h4>
									<p>Use contextual classes to color table rows or individual cells.</p>
									<TableCard code={code8}>
										<table className="table mb-0">
											<thead>
												<tr>
													<th scope="col">Class</th>
													<th scope="col">Heading</th>
													<th scope="col">Heading</th>
												</tr>
											</thead>
											<tbody>
												<tr className="table-active">
													<th scope="row">Active</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr>
													<th scope="row">Default</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="table-primary">
													<th scope="row">Primary</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="table-secondary">
													<th scope="row">Secondary</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="table-success">
													<th scope="row">Success</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="table-danger">
													<th scope="row">Danger</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="table-warning">
													<th scope="row">Warning</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="table-info">
													<th scope="row">Info</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="table-light">
													<th scope="row">Light</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="table-dark">
													<th scope="row">Dark</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="bg-primary text-white">
													<th scope="row">Warning</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="bg-success text-white">
													<th scope="row">Info</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="bg-warning text-white">
													<th scope="row">Light</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="bg-danger text-white">
													<th scope="row">Dark</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
												<tr className="bg-info text-white">
													<th scope="row">Dark</th>
													<td>Cell</td>
													<td>Cell</td>
												</tr>
											</tbody>
										</table>
									</TableCard>
								</div>
								<div id="captions" className="mb-5">
									<h4>Captions</h4>
									<p>
										A <code>&lt;caption&gt;</code> functions like a heading for a table. It helps
										users with screen readers to find a table and understand what it’s about and
										decide if they want to read it.
									</p>
									<TableCard code={code9}>
										<table className="table mb-0">
											<caption>List of users</caption>
											<thead>
												<TableHeader />
											</thead>
											<StandardRows />
										</table>
									</TableCard>
								</div>
								<div id="responsiveTables" className="mb-5">
									<h4>Responsive tables</h4>
									<p>
										Responsive tables allow tables to be scrolled horizontally with ease. Make any
										table responsive across all viewports by wrapping a <code>.table</code> with{' '}
										<code>.table-responsive</code>. Or, pick a maximum breakpoint with which to have
										a responsive table up to by using{' '}
										<code>.table-responsive{'{-sm|-md|-lg|-xl}'}</code>.
									</p>
									<TableCard code={code10}>
										<div className="table-responsive">
											<table className="table mb-0">
												<thead>
													<tr>
														<th scope="col">#</th>
														{Array.from({ length: 9 }).map((_, index) => (
															<th scope="col" key={index}>
																Heading
															</th>
														))}
													</tr>
												</thead>
												<tbody>
													{[1, 2, 3].map((row) => (
														<tr key={row}>
															<th scope="row">{row}</th>
															{Array.from({ length: 9 }).map((_, index) => (
																<td key={index}>Cell</td>
															))}
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</TableCard>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#basicTable" data-toggle="scroll-to">
											Basic table
										</a>
										<a className="nav-link" href="#tableHeadOptions" data-toggle="scroll-to">
											Table head options
										</a>
										<a className="nav-link" href="#stripedRows" data-toggle="scroll-to">
											Striped rows
										</a>
										<a className="nav-link" href="#borderedTable" data-toggle="scroll-to">
											Bordered table
										</a>
										<a className="nav-link" href="#borderlessTable" data-toggle="scroll-to">
											Borderless table
										</a>
										<a className="nav-link" href="#hoverableRows" data-toggle="scroll-to">
											Hoverable rows
										</a>
										<a className="nav-link" href="#smallTable" data-toggle="scroll-to">
											Small table
										</a>
										<a className="nav-link" href="#contextualClasses" data-toggle="scroll-to">
											Contextual classes
										</a>
										<a className="nav-link" href="#captions" data-toggle="scroll-to">
											Captions
										</a>
										<a className="nav-link" href="#responsiveTables" data-toggle="scroll-to">
											Responsive tables
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default TableElements;
